import Vue from "vue";
import Vuex from "vuex";

import { SAVE_SELECTED_PRODUCT } from "./mutation-types";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedProduct: null,
    // selectedProduct: {
    //   model: "M TH720",
    //   cargo_dimensions: "720 x 244 x 52 M",
    //   total_length: "870 x 255 x 52 M",
    //   axles: "3 X AS 1800 KG",
    //   weight: "3500 KG",
    //   own_mass: "760 KG",
    //   loading_capacity: "2740 KG",
    //   price: "€ 5610",
    //   img: "images/mobilhaz/3tengelyes2.png",
    // },
  },

  mutations: {
    [SAVE_SELECTED_PRODUCT](state, payload) {
      Vue.set(state, "selectedProduct", payload);
    },
  },
  actions: {
    saveSelectedProduct(context, payload) {
      context.commit("SAVE_SELECTED_PRODUCT", payload);
    },
  },
  modules: {},
});
